import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateOpportunityLostReasonRequest extends BaseUpdateRequest {
    name = '';
}
